import { atom } from 'recoil'

export const devMode = atom({
  key: 'devMode',
  default: Boolean(sessionStorage.getItem('DEV_MODE'))
})
